<template>
    <div style="position: relative;height: 70px;margin-top:5px; text-align: center;">
        <!-- <div v-if="showErrorLocate" style="position:fixed;top:125px;background: yellow;">
            <div style="font-size: 12px;color:#ed4014;">
                <Icon type="md-pin" size="14" color="lightgray" />定位失败,请选择您所在的省/市</div>
        </div> -->
        <Cascader v-model="value" :data="citys" :placeholder="holdertext" trigger="click" change-on-select @on-change="onChange" @on-visible-change="onManualLocate">
            <!-- <Tag color="primary">primary</Tag> -->
            <a href="javascript:void(0)" style="display: block;height:auto;">
                <div class="container">
                    <div class="item item-1">
                        <Icon type="md-pin" size=15 :color="iconColor" :style="{position:'relative',left:'-5px',display:autoLocate?'inline-block':'none'}" />{{value2[0].label}}</div>
                    <div class="item item-2">
                        <Icon type="md-pin" size=15 :color="iconColor" :style="{position:'relative',left:'-5px',display:autoLocate?'inline-block':'none'}" />{{value2[1]!==undefined?value2[1].label:""}}</div>
                </div>
                <div style="margin-top:10px;">切换到其他城市</div>
            </a>
        </Cascader>
        <Spin fix v-if="show" class="spinbg">
            <Icon type="ios-pin" size=22 class="demo-spin-icon-load"></Icon>
            <div>{{locateDesc}}</div>
        </Spin>
    </div>
</template>
<script type="text/javascript">
//import Citys from '../../../assets/json/region.json'
import eventBus from "../event_bus.js"
import store from '../../../store/'
import ConstJson from "../../../api/common/constjson.js"
let constJ = new ConstJson()
export default {
    name: "CityOptions",
    inject: ["showMain", "localTreeId"],
    data() {
        return {
            citys: this.getProvinceCity(), //Citys,
            value: [{ label: "　", value: "" },
                { label: "　", value: "" }
            ],
            // value: [
            //     { label: "北京", value: "110000" },
            //     { label: "东城区", value: "110101" }
            // ],
            value2: [{ label: "　", value: "" },
                { label: "　", value: "" }
            ],
            holdertext: '请选择',
            show: true,
            iconColor: '#19be6b',
            selectLocation: [],
            showErrorLocate: false,
            classid: "",
            locateDesc: "基于您的IP地址定位...",
            autoLocate: false,
        }
    },
    created() {
        // setTimeout(() => {
        //   this.show = false
        //   this.value = [{label:"北京",value:"001"}, {label:"东城区",value:"001001"}]
        // }, 1000 * 2)

        // //不带classid
        // this.classid = this.localTreeId

        this.showMain(true)
        constJ.ReqGetLocation().then(res => {
            console.log(res)
            if (res.rltcode === 1) {
                if (res.rtncode === 1) {
                    // this.value[0].label = "四川"
                    // this.value[0].value = "510000"
                    // this.value[1].label = "成都"
                    // this.value[1].value = "510100"

                    this.value = []
                    this.value.push(res.postion.provice)
                    this.value.push(res.postion.city)

                    this.value2 = []
                    var p = {
                        label: res.postion.provicelabel,
                        value: res.postion.provice
                    }
                    var c = {
                        label: res.postion.citylabel,
                        value: res.postion.city
                    }
                    this.value2.push(p)
                    this.value2.push(c)
                    //取会定位信息成功，显示定位UI
                    this.autoLocate = true
                } else {
                    this.locateDesc = res.rtncode
                    this.showErrorLocate = true
                }
            } else {
                if (res.rltcode === -1) {
                    this.autoLocate = false
                    this.showErrorLocate = true
                    this.value2 = []
                    var p = {
                        label: res.postion.provicelabel,
                        value: res.postion.provice
                    }
                    this.value2.push(p)
                } else {
                    //-9998
                    this.locateDesc = res.rltdesc
                    this.showErrorLocate = true
                }
            }

            // if(this.value2[0].label==='' && this. value2[1].label===''){
            //     this.showErrorLocate=true
            // }
            this.show = false
            this.showMain(false)
            this.$emit("on-city-changed", this.value2)
            this.gotoRoute2("localindex")
        }).catch(err => {
            this.locateDesc = "定位失败,请手动选择"
            setTimeout(() => {
                this.value2 = this.value
                this.value = Array.from(this.value, (x) => x.value)

                this.show = false
                this.showMain(false)
                this.$emit("on-city-changed", this.value2)
                this.gotoRoute2("localindex")
            }, 1000 * 2)
            console.log(err)
        })

    },
    mounted() {
        //JSON.parse(JSON.stringify(data).replace(/title/g, 'name')) 
        //console.log("go...")
        //console.log(this.value)
        //接受來自search_main的tree selected消息
        // this.$nextTick(function() {

        // })

        // eventBus.$on('on-localTree-selected', (value) => {
        //   console.log("city----->aside_menu.onCityChanged")
        //   //eventBus.$emit("city-select", value)
        //   this.$emit("on-city-changed", value.city,value.classid)
        // })

    },
    // beforeDestroy() {
    //   eventBus.$off('on-localTree-selected')
    // },
    methods: {
        getProvinceCity() {
            let res = store.state.user.initData.provinceCity
            return res
        },
        onChange(val, data) {
            this.showMain(false)
            console.log(data)
            this.selectLocation = data
            this.value = data
            if (this.value) {
                if (this.value.length === 1) {
                    this.value2 = []
                    var p = {
                        label: this.value[0].label,
                        value: this.value[0].value
                    }
                    this.value2.push(p)
                }
                if (this.value.length === 2) {
                    this.value2 = []
                    var p = {
                        label: this.value[0].label,
                        value: this.value[0].value
                    }
                    var c = {
                        label: this.value[1].label,
                        value: this.value[1].value
                    }
                    this.value2.push(p)
                    this.value2.push(c)
                }
                this.autoLocate = false
                this.showErrorLocate = false
            }


            //eventBus.$emit("city-select", data)  //改为由search_main统一发射到search_local_main
            // this.iconColor='#c5c8ce'
            this.$emit("on-city-changed", this.value2) //告知到左侧树所选的城市数据
            //this.gotoRoute("localindex", data)
        },
        onManualLocate(isChange) {
            //console.log(this.selectLocation)
            if (isChange === false && this.selectLocation.length > 0) {
                //this.iconColor = '#c5c8ce'
                this.autoLocate = false
            }
        },
        gotoRoute(rName, args) {
            this.$router.push({
                name: rName,
                query: {
                    city: args[1],
                    province: args[0],
                    classid: this.classid,
                }
            })
        },
        gotoRoute2(rName) {
            this.$router.push({
                name: rName
            })
        }
    },
    watch: {
        localTreeId: function(value) {
            console.log('i am in city,my node value change to:' + value)
        }
    },
}
</script>
<style scoped>
/*spin style*/
/*rgb(240 244 250 / 100%) = #f0f4fa*/
.spinbg{
    background-color: rgb(240 244 250 / 100%)
}

.demo-spin-icon-load {
    /*animation: ani-demo-spin 1s linear infinite;*/
    animation: blink 1s infinite;
    -webkit-animation: blink 1s infinite;
    /*Safari and Chrome*/

}


@keyframes blink {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 100;
    }

    100% {
        opacity: 0;
    }
}

@-webkit-keyframes blink {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 100;
    }

    100% {
        opacity: 0;
    }
}

/*@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}*/

.demo-spin-col {
    height: 100px;
    position: relative;
    border: 1px solid #eee;
}

.container {
    width: 180px;
    /*  height: 26px;*/
    display: inline-grid;
    grid-template-columns: 50% 50%;
    margin: auto;
}

.item {
    font-size: 12px;
    text-align: center;
    border: 1px solid #2d8cf0;
    color: #17233d;
    padding: 5px;
    font-weight: bold;
    /*  height:40px;
  line-height: 40px;*/
}

.item-1 {
    background-color: white;
    margin-right: 5px;

}

.item-2 {
    background-color: white;


}

.item-1:hover {
    background-color: #F4FFF9;
}

.item-2:hover {
    background-color: #F4FFF9;
}
</style>